import { motion } from "framer-motion";

/**
 * Generic process steps section.
 * heading, subheading, eyebrow, steps:[{title, description, icon?}]
 */
export const ProcessSteps = ({
  eyebrow = "How It Works",
  heading,
  subheading,
  steps = [],
  background = "white",
}) => {
  const bgClass = background === "slate" ? "bg-slate-50" : "bg-white";

  return (
    <section
      className={`py-20 md:py-28 ${bgClass}`}
      data-testid="process-section"
    >
      <div className="container mx-auto px-6 md:px-12 lg:px-20">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-14"
        >
          <span className="text-teal font-semibold text-sm uppercase tracking-wider">
            {eyebrow}
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-semibold text-navy mt-3 mb-4">
            {heading}
          </h2>
          {subheading && (
            <p className="text-slate-600 text-lg max-w-2xl mx-auto">
              {subheading}
            </p>
          )}
        </motion.div>

        <div className="relative max-w-5xl mx-auto">
          {/* Connector line on desktop */}
          <div className="hidden md:block absolute top-12 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />

          <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-8 relative">
            {steps.map((step, i) => (
              <motion.div
                key={step.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.08 }}
                className="text-center"
                data-testid={`process-step-${i}`}
              >
                <div className="relative inline-flex items-center justify-center w-24 h-24 mb-6">
                  <div className="absolute inset-0 bg-gold/10 rounded-full" />
                  <div className="relative w-20 h-20 bg-white border-2 border-gold rounded-full flex items-center justify-center font-heading text-2xl font-bold text-navy">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                </div>
                <h3 className="font-heading text-xl font-semibold text-navy mb-3">
                  {step.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed">
                  {step.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
